export default __webpack_public_path__ + "0ce2053535ff0b4ccdbc9ed6e82d05aa.svg";